import {
	DocumentLegend as Dl,
	EventLegend as El,
	ProtagonistLegend as Pl,
	MainTimelineLegend as MTL,
} from './Legend';

export const DocumentLegend = Dl;
export const EventLegend = El;
export const ProtagonistLegend = Pl;
export const MainTimelineLegend = MTL;
